import React from "react"
import CtaButtons from "./CtaButtons.jsx"
import HealthCheckCTA from "../HealthCheckCTA.jsx"

export default function FinalCTA({ service }) {
  return (
    <section aria-labelledby="final-cta-heading" className="bg-brand-navy py-20 text-white sm:py-24">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
        <h2
          id="final-cta-heading"
          className="text-3xl font-bold leading-tight tracking-tight sm:text-4xl"
        >
          Let&rsquo;s discuss your next stage of digital growth.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-blue-100">
          Tell us where your business is heading and what is holding your digital presence back.
          We will come back with clear, practical next steps and a tailored quote where it makes
          sense.
        </p>

        <CtaButtons tone="light" className="mt-10 justify-center" service={service} />

        <div className="mx-auto mt-12 max-w-xl border-t border-white/15 pt-8">
          <p className="text-sm text-blue-100">
            Not ready for a project conversation? Start with a free website health check covering
            performance, SEO and mobile usability.
          </p>
          <div className="mt-4">
            <HealthCheckCTA
              buttonLabel="Request a Free Health Check"
              className="!bg-orange-700 hover:!bg-orange-800"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
